/* global __BUILD_ID__ */
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

// 빌드 시점 ID (config-overrides.js의 DefinePlugin 주입). 번역 파일 URL에 ?v= 로 붙여
// 배포마다 URL이 바뀌게 해, 브라우저가 옛 번역 캐시를 재사용하지 않도록 한다.
const buildId = typeof __BUILD_ID__ !== 'undefined' ? __BUILD_ID__ : 'dev';

// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'en',
    debug: false,

    // 번역 파일 URL에 빌드 버전 쿼리(?v=)를 붙여 배포마다 브라우저 캐시를 무효화
    backend: {
      queryStringParams: { v: buildId },
    },

    // 부팅 시 미리 받는 번역 파일 — 항상 떠 있는 화면(헤더/푸터/에러 경계)과
    // 랜딩 첫 화면(홈+검색박스+FAQ)에 필요한 것만. 나머지(auth/listing/cart/order/
    // mypage/shortlist/reservation/request-room)는 해당 페이지 진입 시
    // useTranslation(ns)이 자동 로딩하고, 페이지가 lazy라 Suspense가 대기를 처리한다.
    // (korean-housing-info·review 등은 원래부터 이 자동 로딩 방식으로 동작해 왔음)
    // ⚠️ common·error는 Suspense 바깥(헤더/QueryErrorBoundary)에서 쓰므로 반드시 유지.
    ns: ['common', 'home', 'search', 'guide', 'error'],
    defaultNS: 'common',

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    // 지원하는 언어: 영어(en), 베트남어(vi), 중국어(zh), 일본어(ja)
    // 영어는 기본 언어로 언어 경로 없이 처리, 나머지 언어는 언어 경로로 처리
    supportedLngs: ['en', 'vi', 'zh', 'ja'],

    // Add detection options
    detection: {
      order: ['path', 'navigator', 'cookie', 'localStorage', 'subdomain'],
    },
  });

// HTML lang 속성을 현재 언어와 동기화 (CSS :lang() 선택자용)
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

// Noto Sans SC(중국어 글리프 폴백 폰트)는 zh에서만 주입.
// CJK unicode-range 선언 때문에 CSS만 121KiB라, index.html에 두면 전 언어
// 방문자가 전량 받게 된다 (Lighthouse unused-css 1위였음). 이 앱은 JS 없이는
// 렌더되지 않는 SPA라 noscript 폴백은 애초에 무의미해서 두지 않는다.
const NOTO_SC_HREF = 'https://fonts.googleapis.com/css2?family=Noto+Sans+SC:wght@400;500;600;700&display=swap';

function ensureChineseFont(lng) {
  if (!lng || !lng.startsWith('zh')) return;
  if (document.querySelector(`link[href="${NOTO_SC_HREF}"]`)) return;

  // 폰트 파일 호스트 연결 준비 — 스타일시트 링크보다 먼저 넣어야 효과가 있다
  const preconnect = document.createElement('link');
  preconnect.rel = 'preconnect';
  preconnect.href = 'https://fonts.gstatic.com';
  preconnect.crossOrigin = 'anonymous';
  document.head.appendChild(preconnect);

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = NOTO_SC_HREF;
  document.head.appendChild(link);
}

// init 완료 시(언어 확정) languageChanged 가 한 번 발화하므로 부팅 경로도 커버된다
i18n.on('languageChanged', ensureChineseFont);
ensureChineseFont(i18n.language);

export default i18n;
